export default __webpack_public_path__ + "static/media/commercial_loans.e5b6c7a7.jpg";